import React from 'react';
import {  useLocation, } from "react-router-dom";
import iframePreview from '../../assets/Images/iframe-preview.webp';
import { useSelector, } from "react-redux";

const Iframe = ({
  id,
  elementAttr: {
    url, border, margin, padding,
  },
}) => {
  const location = useLocation();
  // const { viewType } = useSelector((state) => state.duonutSettings);

  const clickIframe = (e) => {
    e.preventDefault()
  }

  return (
    <div style={{ display: "flex", justifyContent: "center", width: '100%', height: '100%', position: "relative" }}
      onClick={(e) => clickIframe(e)}>
      {url ? <>
        <iframe src={url} frameborder="0"
          title="Dynami Tech Iframe"
          style={{
            maxWidth: '100%', maxHeight: '100%', width: '100%', height: '100%',
            border, margin, padding
          }}></iframe>

        <div
          style={{
            position: 'absolute',
            top: 0,
            left: 0,
            width: '100%',
            height: '100%',
            backgroundColor: 'transparent',
            display: (location.pathname).includes("/duonut/") ? "none" : 'block'
            // cursor: 'not-allowed'
          }}
          onClick={clickIframe}
        /></>
        : <img src={iframePreview} style={{
          maxWidth: '100%', maxHeight: '100%', objectFit: "cover",
          cursor: (location.pathname).includes("/duonut/") ? "default" : 'default',
          border, margin, padding
        }} alt="" />}
    </div>
  );
}

export default Iframe;
